import {
    IFeedbackModel,
} from '../../util/Request/requestType';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';

interface IFeedbackPageModel {
    feedbackList: IFeedbackModel[]
}
const initialState: IFeedbackPageModel = {
    feedbackList: []
};
export const feedbackSlice = createSlice({
    name: 'feedbackList',
    initialState,
    reducers: {
        submitFeedback: (state, action: PayloadAction<IFeedbackPageModel>) => {
            const newfeedbackLists = [...action.payload.feedbackList];
            return {
                feedbackList: newfeedbackLists
            };
        }
    }
});

export type {
    IFeedbackPageModel
};

export const {
    submitFeedback
} = feedbackSlice.actions;

export const selectSoilPropertyList = (state: RootState) => state.referencePageData;
export default feedbackSlice.reducer;

